import React, { useState, useEffect } from "react";
import {
    Button,
    Chip,
    colors,
    Container,
    Grid,
    Hidden,
    makeStyles,
    Paper,
    TextField,
    Typography,
} from "@material-ui/core";
import { useHistory } from "react-router-dom";
import {
    useStylesCAB,
    useStylesContainers,
    useStylesDPM,
    useStylesHed,
    useStylesSpDial,
    useStylesUiElemment,
} from "../../../St/comps/UseStyle";
import { insh as inshst } from "../../../Context/InshSt";
import clsx from "clsx";

import { useTranslation } from "react-i18next";
import BeatLoader from "react-spinners/BeatLoader";
import i18next from "i18next";
import { TableChart } from "@material-ui/icons";
import { CSVLink } from "react-csv";
import moment from "moment";
import axios from "axios";
import toast from "react-hot-toast";
import { sto } from "../../../Context/InshData";
import DeleteConfirmDialog from "../../../components/DeleteConfirmDialog";
import { uri } from "../../../help/Api";
import { useStylesBA } from "../../../St/comps/UseStyle";
import { insh, wsto } from "../../../Context/InshData";
import LevelsTable from "./LevelsTable";
import PumpsAppbar from "../Pumps/PumpsAppbar";
import { useStylesLbl } from "../../../St/Reports/UseStyle";


const useStyles = makeStyles((theme) => ({
    root: {
        // backgroundColor: theme.palette.background.dark,
        minHeight: "100%",
        paddingBottom: theme.spacing(3),
    },
    itemW: {
        // display:'flex',
        width: "90%",
    },
    headerTitle: {
        backgroundColor: colors.red[50],
        textAlign: "center",
        fontSize: 20,
        width: "100%",
    },

    allWidth: {
        minWidth: 650,
    },
    checStyl: {
        marginTop: "17px",
        fontSize: "16px",
        padding: "-1px",
    },
    purchTotalCard: {
        backgroundColor: colors.red[50],
        borderColor: colors.red[300],
    },
}));

export default function Levels(props) {
    const { AutoOptions,
    } = props;
    const clasess = useStyles();

    const valueLevel = {
        id: AutoOptions?.other?.lastid ?? 1,
        name: "",
        db_name:sto?.db_name,
    };
    const clasCAB = useStylesCAB();
    const [loading, setLoading] = useState(insh.LoadAndSucc);
    const [success, setSuccess] = useState(insh.LoadAndSucc);
    const classes = useStyles();
    const clasui = useStylesUiElemment();
    const clasSp = useStylesSpDial();
    const [data, setData] = useState([]);
    const [fetching, setFetching] = useState(false);
    const [prevent, setPrevent] = React.useState(true);
    const [rptParams, setRptParams] = React.useState(valueLevel);
    const [uiElement, setUiElement] = useState({});
    const claslbl = useStylesLbl();

    const clasBA = useStylesBA();

    const [levelsReports, setLevelsReports] = React.useState(AutoOptions?.Levels);


    const { t } = useTranslation(["forms"]);
    const ButtonLoading = (prop) => setLoading({ ...loading, [prop]: true });

    const timer = React.useRef();
    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false });
    const [setting, setSetting] = useState({
        screen: "",
        tb: { parms: {}, autos: {} },
    });

    const [style, setStyle] = useState({});
    const his = useHistory();

    const buttonClassnameNew = clsx({ [clasCAB.buttonSuccessCAB]: success?.new });
    const buttonClassnameSave = clsx({
        [clasCAB.buttonSuccessCAB]: success.save,
    });
    const buttonClassnameDelete = clsx({
        [clasCAB.buttonSuccessCAB]: success.delete,
    });

    const backHome = () => {
        his.push({ pathname: "/" });
    };
    const back = () => {
        his.goBack();
    };
    const newToI = (timr) => {
        ButtonLoading("new");
        ButtonSuccess("new", timr);
        setPrevent(true);
    };


    const changTField = (prop) => (e) => {
        setRptParams({ ...rptParams, [prop]: e.target.value });
    };
    const onRowClick = async (row) => {
        setPrevent(false);
        setRptParams({
            ...rptParams,
            id: row.id,
            name: row.name,
        });
    };


    const reloadGets = async () => {
        const tb = {
            wait: true,
            other: true,
            Levels: true,
            parms: {
                iempid: sto.empi,
                tname: "pump",
                branch: sto.branchi,
                db_name:sto?.db_name,
            },
        };

        await axios
            .post(uri + "GetD", tb)
            .then((res) => {
                setLevelsReports(res.data?.Levels);
                setRptParams({
                    ...valueLevel,
                    id: res.data.other?.lastid
                });
            })
            .catch((error) => {
            });
    };

    const handNewLevel = () => {
        reloadGets();
        setRptParams(valueLevel);
        setPrevent(true);
    };
    const ButtonSuccess = (prop, timr) => {
        timer.current = window.setTimeout(() => {
            setLoading({ ...loading, [prop]: false });
            setSuccess({ ...success, [prop]: true });
            if (prop === "save") { handNewLevel(); }
            if (prop === "update") { handNewLevel(); }

            else if (prop === "delete") { handNewLevel(); }
            else {
                handNewLevel();
            }
            setPrevent(true);
        }, 2000);
    };

    const addToBS = (props) => {
        ButtonLoading("save");
        if (rptParams.name != null && rptParams.name != "") {
            prevent
                ? axios
                    .post(uri + "Levels", rptParams)
                    .then((res) => {
                        if (res.data?.data != null) {

                            ButtonSuccess("save", 1000);
                            toast.success(t("save-success"));
                        } else {
                            ButtonSuccess("save", 1000);
                            toast.success(t("save-success"));
                        }

                    })
                    .catch((res) => {
                        ButtonSuccess("save", 1000);
                        toast.error(t("save-failed"));

                    })
                :
                axios
                    .put(uri + "Levels", rptParams)
                    .then((res) => {
                        ButtonSuccess("update", 1000);
                        toast.success(t("update-success"));
                    })
                    .catch((res) => {
                        ButtonSuccess("update", 1000);
                        toast.error(t("update-process-error"));

                    });
        } else {
            alert(t("confirm-complete-data"));
        }
    };



    const handleDeleteRow = async (e, row) => {


        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
          Urls = `Levels?id=${row?.id}`
        } else {
          Urls = `Levels?id=${row?.id}&&db_name=${sto?.db_name}`
        }
        await axios.delete(uri +Urls).then(res => {
            if (res.data === "no") {
                alert(t("cant-delete-level"));
            } else {
                toast.success(t("delete-success"));
                ButtonSuccess("delete", 1000);
            }

        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error(t("delete-failed"))
        })
    };

    const deleteToI = async (e) => {


        await e.preventDefault();
        setConfirmDialog({ ...confirmDialog, isOpen: false });
        ButtonLoading("delete");
        let Urls = null;
        if (sto.db_name === "" || sto.db_name === null) {
          Urls = `Levels?id=${rptParams?.id}`
        } else {
          Urls = `Levels?id=${rptParams?.id}&&db_name=${sto?.db_name}`
        }
        await axios.delete(uri + Urls).then(res => {
            toast.success(t("delete-success"));
            ButtonSuccess("delete", 1000);
        }).catch(err => {
            console.log("eror", err)
            ButtonSuccess("delete", 1000);
            toast.error(t("delete-failed"))
        })
    };
    return (
        <div className={classes.root}>
            <Grid container item xs={12}>
                <Typography
                    size="small"
                    className={classes.headerTitle}
                    style={{ backgroundColor: colors.red[50], fontWeight: "bold" }}
                    color="primary"
                >
                    {t("define-levels")}
                </Typography>
            </Grid>
            <Typography
                component="div"
                style={{ direction: i18next.language == "ar" ? "rtl" : "ltr" }}
            >
                <Grid container item lg={12} md={12} sm={12} xm={12} className={clasui.rootchip} >
                    <Grid container item lg={2} md={2} sm={12} xm={12} className={clasui.rootchip} ></Grid>

                    <Grid container item lg={8} md={8} sm={12} xm={12} className={clasui.rootchip} >

                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                paddingBottom: "0px",
                                borderBottomColor: colors.green[300],
                                borderBottomWidth: "1px",
                                borderBottomStyle: "solid",
                            }}
                        >
                            <Grid item lg={12} md={12} sm={12} xs={12} style={{ marginBottom: "0.5rem" }}>
                                <TextField
                                    fullWidth
                                    variant="outlined"
                                    size="small"
                                    id="barcode"
                                    label={t("level-name")}
                                    type="text"
                                    name="name"
                                    value={rptParams.name}
                                    InputLabelProps={{
                                        className: claslbl.clrBlackLblS,

                                    }}
                                    InputProps={{ className: claslbl.clrBlackTxt }}
                                    onChange={changTField("name")}
                                />
                            </Grid>

                        </Container>
                    </Grid>
                    <Grid container item lg={2} md={2} sm={12} xm={12} className={clasui.rootchip} ></Grid>
                    <Grid container item lg={2} md={2} sm={12} xm={12} className={clasui.rootchip} ></Grid>

                    <Grid container lg={8} md={8} sm={12} xm={12} className={clasui.rootchip}>
                        <Container
                            component={Paper}
                            maxWidth={false}
                            style={{
                                padding: "10px",
                                marginTop: "0.5rem"
                            }}
                        >
                            <Grid container justifyContent="center">
                                <Grid item container justifyContent="center" xs={12}>
                                    <BeatLoader loading={fetching} color={colors.red[300]} />
                                    {!fetching && (
                                        <LevelsTable
                                            {...{
                                                data: levelsReports ? levelsReports : [],
                                                setConfirmDialog,
                                                handleDeleteRow,
                                                onRowClick
                                            }}
                                        />
                                    )}
                                </Grid>
                            </Grid>
                        </Container>
                    </Grid>
                    <Grid container item lg={2} md={2} sm={12} xm={12} className={clasui.rootchip} ></Grid>

                </Grid>
                <DeleteConfirmDialog
                    confirmDialog={confirmDialog}
                    setConfirmDialog={setConfirmDialog}
                />
            </Typography>
            <PumpsAppbar {...{
                rptParams,
                buttonClassnameNew,
                buttonClassnameSave,
                buttonClassnameDelete,
                clasCAB,
                newToI,
                setting,
                deleteToI,
                addToBS,
                loading,
                clasBA,
                backHome,
                back,
                uiElement,
                prevent
            }}
            />
        </div>
    );
}
